var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _vm.canEdit
      ? _c(
          "a",
          {
            staticClass: "edit",
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$emit("edit", ["calendar", $event.target])
              },
            },
          },
          [_vm._v("\n    " + _vm._s(_vm.tc("booking.edit")) + "\n  ")]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "section-label" }, [
      _vm._v("\n    " + _vm._s(_vm.tc("booking.date")) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "dates" }, [
      _c("div", {
        staticClass: "start-date bold-item",
        domProps: { innerHTML: _vm._s(_vm.formatDate(_vm.startDate)) },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "end-date bold-item",
        domProps: { innerHTML: _vm._s(_vm.formatDate(_vm.endDate)) },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "times" }, [
      _c("div", { staticClass: "check-in" }, [
        _c("div", { staticClass: "section-label small" }, [
          _vm._v("\n        " + _vm._s(_vm.tc("booking.checkIn")) + "\n      "),
        ]),
        _vm._v(
          "\n      " +
            _vm._s(_vm.tc("booking.after")) +
            " " +
            _vm._s(_vm.formatTime(_vm.startDate)) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "check-out" }, [
        _c("div", { staticClass: "section-label small" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.tc("booking.checkOut")) + "\n      "
          ),
        ]),
        _vm._v(
          "\n      " +
            _vm._s(_vm.tc("booking.before")) +
            " " +
            _vm._s(_vm.formatTime(_vm.endDate)) +
            "\n    "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }